import {MiddlewareValue} from '../../../types';
import {ScratchpadVersion} from './types';

export const versionField = {
  key: 'version',
  type: MiddlewareValue.U_INT_8,
} as const;

// The order of the items in the array is important for serializing the scratchpad
// Do not modify it
export const encodings = {
  [ScratchpadVersion.LANTERN_CUSTOM]: [
    {key: 'moodUlid', type: MiddlewareValue.ULID},
    {key: 'moodName', type: MiddlewareValue.STRING, length: 32},
    {key: 'moodDateModified', type: MiddlewareValue.U_INT_32},
    {key: 'moodType', type: MiddlewareValue.U_INT_8},
    {key: 'tempo', type: MiddlewareValue.FLOAT},
    {key: 'colors', type: MiddlewareValue.COLORS, length: 18},
    {key: 'originalMoodUlid', type: MiddlewareValue.ULID},
  ],
  [ScratchpadVersion.LANTERN_EXCLUSIVE]: [
    {key: 'moodUlid', type: MiddlewareValue.ULID},
  ],
  [ScratchpadVersion.PROFILE]: [
    {key: 'heatProfileUlid', type: MiddlewareValue.ULID},
    {key: 'heatProfileDateModified', type: MiddlewareValue.U_INT_32},
  ],
  [ScratchpadVersion.PROFILE_CUSTOM]: [
    {key: 'heatProfileUlid', type: MiddlewareValue.ULID},
    {key: 'heatProfileDateModified', type: MiddlewareValue.U_INT_32},
    {key: 'moodUlid', type: MiddlewareValue.ULID},
    {key: 'moodName', type: MiddlewareValue.STRING, length: 32},
    {key: 'moodDateModified', type: MiddlewareValue.U_INT_32},
    {key: 'moodType', type: MiddlewareValue.U_INT_8},
    {key: 'tempo', type: MiddlewareValue.FLOAT},
    {key: 'colors', type: MiddlewareValue.COLORS, length: 18},
    {key: 'originalMoodUlid', type: MiddlewareValue.ULID},
  ],
  [ScratchpadVersion.PROFILE_EXCLUSIVE]: [
    {key: 'heatProfileUlid', type: MiddlewareValue.ULID},
    {key: 'heatProfileDateModified', type: MiddlewareValue.U_INT_32},
    {key: 'moodUlid', type: MiddlewareValue.ULID},
  ],
  [ScratchpadVersion.BLANK]: [],

  [ScratchpadVersion.LANTERN_CUSTOM_0]: [
    {key: 'moodUlid', type: MiddlewareValue.ULID},
    {key: 'moodName', type: MiddlewareValue.STRING, length: 32},
    {key: 'moodDateModified', type: MiddlewareValue.U_INT_32},
    {key: 'moodType', type: MiddlewareValue.U_INT_8},
    {key: 'tempo', type: MiddlewareValue.FLOAT},
    {key: 'colors', type: MiddlewareValue.COLORS, length: 18},
  ],
  [ScratchpadVersion.PROFILE_CUSTOM_0]: [
    {key: 'heatProfileUlid', type: MiddlewareValue.ULID},
    {key: 'heatProfileDateModified', type: MiddlewareValue.U_INT_32},
    {key: 'moodUlid', type: MiddlewareValue.ULID},
    {key: 'moodName', type: MiddlewareValue.STRING, length: 32},
    {key: 'moodDateModified', type: MiddlewareValue.U_INT_32},
    {key: 'moodType', type: MiddlewareValue.U_INT_8},
    {key: 'tempo', type: MiddlewareValue.FLOAT},
    {key: 'colors', type: MiddlewareValue.COLORS, length: 18},
  ],
};
